import configJson from "./Config.json";

const CommonObj = {
  Endpoints: {
    Books: configJson.baseUrl + "/Api/book/GetBookDetailsByISBN",
    SaveBookDetails: configJson.baseUrl + "/Api/intake/SaveBookIntakeDetails",
    GetCancelBookDetails:
      configJson.baseUrl + "/Api/intake/GetBookCancelDetails",
    UpdateBookDetails:
      configJson.baseUrl + "/Api/intake/UpdateBookIntakeDetails",
    GetBookDetails: configJson.baseUrl + "/Api/intake/GetIntakeDetails",
    GetDeliverytoS3QueueDetails:
      configJson.baseUrl + "/Api/Delivery/GetBookDeliverytoS3QueueDetails",
    GetManifestBooks: configJson.baseUrl + "/Api/Manifest/GetManifestBooks",
    ManifestAcceptanceList:
      configJson.baseUrl + "/api/Manifest/GetManifestAcceptanceList",
    GetBookByBIDandStatus: configJson.baseUrl + "/api/Cutting/GetBookByBID",
    GetBIDStatus: configJson.baseUrl + "/api/Cutting/GetBIDStatus",
    GetBatchBIDStatus: configJson.baseUrl + "/api/Cutting/GetBatchBIDStatus",
    GetScanningBookByBID: configJson.baseUrl + "/api/Scanning/GetBookByBID",
    GetScanningBIDStatus: configJson.baseUrl + "/api/Scanning/GetBIDStatus",
    SaveManifestRackDetails:
      configJson.baseUrl + "/api/Manifest/SaveManifestRackDetails",
    GetRejectionTypes: configJson.baseUrl + "/api/Manifest/GetRejectionTypes",
    DownloadManifest: configJson.baseUrl + "/api/Manifest/DownloadManifest",
    AcceptManifest: configJson.baseUrl + "/api/Manifest/AcceptManifest",
    RejectManifest: configJson.baseUrl + "/api/Manifest/RejectManifest",
    BookOperatorSubmit: configJson.baseUrl + "/api/Cutting/BookOperatorSubmit",
    SubmitCuttingProcess: configJson.baseUrl + "/api/Cutting/SubmitCuttingProcess",
    InsertComments: configJson.baseUrl + "/api/Cutting/CommentInsert",
    GetComments: configJson.baseUrl + "/api/Cutting/CommentsGet",
    GetMasterData: configJson.baseUrl + "/api/Masters/GetMastersData",
    GetMenus: configJson.baseUrl + "/api/Masters/GetMenus",
    UpdateRoleMenuPageApiMapping: configJson.baseUrl + "/api/Masters/UpdateRoleMenuPageApiMapping",
    GetBookinfoByBID: configJson.baseUrl + "/api/Intake/GetBookinfoByBID",
    ScanningNewRackMap: configJson.baseUrl + "/api/Scanning/NewRackMap",
    ScanningOperatorSubmit: configJson.baseUrl + "/api/Scanning/OperatorSubmit",
    ScanningUpdatePageCount:
      configJson.baseUrl + "/api/Scanning/UpdatePageCount",
    ScanningInsertComments: configJson.baseUrl + "/api/Scanning/CommentInsert",
    SaveRackandShelf: configJson.baseUrl + "/api/Cutting/NewRackMap",
    CuttingReject: configJson.baseUrl + "/api/Cutting/CuttingReject",
    CuttingGetRejectTypes: configJson.baseUrl + "/api/Cutting/GetRejectTypes",
    LoginRoles: configJson.baseUrl + "/api/User/GetUserRole",
    TrackUserAction: configJson.baseUrl + "/api/UserAudit/InsertAuditLog",
    GetAuditLogConfig: configJson.baseUrl + "/api/UserAudit/GetAuditLogConfig",
    GetAuditLog: configJson.baseUrl + "/api/UserAudit/GetAuditLog",
    UserSessionLogin: configJson.baseUrl + "/api/UserAudit/UserSessionLogin",
    UserSessionLogout: configJson.baseUrl + "/api/UserAudit/UserSessionLogout",
    QCgetBookByBID: configJson.baseUrl + "/api/QC/GetBookByBID",
    GetQCConfig: configJson.baseUrl + "/api/QC/GetQCConfig",
    UpdateQCConfig: configJson.baseUrl + "/api/QC/UpdateQCConfig",
    QCSubmitQCProcess: configJson.baseUrl + "/api/QC/SubmitQCProcess",
    QCGetComments: configJson.baseUrl + "/api/QC/CommentsGet",
    QCInsertComments: configJson.baseUrl + "/api/QC/CommentInsert",
    QCGetReworkBookDetails: configJson.baseUrl + "/api/QC/GetReworkBookDetails",
    GetClientQueueBookDetails:
      configJson.baseUrl + "/api/Client/GetDeliveredBookDetails",
    GetBookRecycleDetails:
      configJson.baseUrl + "/api/Recycle/GetBookRecycledDetails",
    GetEmptyRackLocation:
      configJson.baseUrl + "/api/Recycle/GetEmptyRackLocation",
    GetReadytoRecycleDetails:
      configJson.baseUrl + "/Api/recycle/GetReadytoRecycle",
    GetClientRejectType: configJson.baseUrl + "/api/Client/GetRejectionTypes",
    ClientQueueAccept: configJson.baseUrl + "/api/Client/ClientAcceptBooks",
    ClientQueueReject: configJson.baseUrl + "/api/Client/ClientRejectBooks",
    GetRecycleManifestDownload:
      configJson.baseUrl + "/api/Client/GetRecycleManifestDownload",
    UpdateRecycleManifestStatus:
      configJson.baseUrl + "/api/Client/UpdateRecycleManifestDownload",
    GetUserList: configJson.baseUrl + "/api/User/GetUserList",
    CreateUserAsync: configJson.baseUrl + "/api/User/CreateUserAsync",
    uploadDeliveryS3: configJson.baseUrl + "/api/Upload/UploadFile",
    GetUploadReport: configJson.baseUrl + "/api/Upload/GetUploadedReport",
    GetTimeZone: configJson.baseUrl + "/api/User/GetTimeZone",
    GetLocations: configJson.baseUrl + "/api/User/GetLocations",
    GetRoles: configJson.baseUrl + "/api/Role/GetRoles",
    GetUserDetailsByNTLoginId:
      configJson.baseUrl + "/api/User/GetUserDetailsByNTLoginId",
    UpdateUserDetails: configJson.baseUrl + "/api/User/Update",
    GetReportData: configJson.baseUrl + "/api/Report/GetReportData",
    GetReportFilters: configJson.baseUrl + "/api/Report/GetReportFilters",
    GetUserById: configJson.baseUrl + "/api/User/GetUserById",
    ExistingUser: configJson.baseUrl + "/api/User/IsUserExistsAsync",
    ExistingEmail: configJson.baseUrl + "/api/User/IsMailExistsAsync",
    GetQCBIDStatus: configJson.baseUrl + "/api/QC/GetBIDStatus",
    CheckEmptyRackSendValidation:
      configJson.baseUrl + "/api/EmptyRack/CheckEmptyRackSendValidation",
    EmptyRackScanInsert:
      configJson.baseUrl + "/api/EmptyRack/EmptyRackScanInsert",
    CheckEmptyRackAcceptValidation:
      configJson.baseUrl + "/api/EmptyRack/CheckEmptyRackAcceptValidation",
    EmptyRackAcceptReject:
      configJson.baseUrl + "/api/EmptyRack/EmptyRackAcceptReject",
    GetBooksByRackNo: configJson.baseUrl + "/api/Manifest/GetBooksByRackNo",
    SkipManifest: configJson.baseUrl + "/api/Manifest/SkipManifest",
    GetClientRejectionTypes:
      configJson.baseUrl + "/api/Client/GetRejectionTypes",
    GetRackStatus: configJson.baseUrl + "/api/Manifest/GetRackStatus",
    GetRejectTypes: configJson.baseUrl + "/api/Scanning/GetRejectTypes",
    GetReworkSubmit: configJson.baseUrl + "/api/Scanning/ReworkSubmit",
    GetScanningReject: configJson.baseUrl + "/api/Scanning/ScanningReject",
    GetRoundInformationforRework:
      configJson.baseUrl + "/api/QC/GetRoundInformationforRework",
    GetReportProcessingDetails:
      configJson.baseUrl + "/api/Report/GetReportProcessDetails",
    GetBookExceptionQueue:
      configJson.baseUrl + "/api/Intake/GetBookExceptionQueue",
    GetISBNStatus: configJson.baseUrl + "/api/Intake/GetISBNStatus",
    GetIntakeBidStatus: configJson.baseUrl + "/api/Intake/GetIntakeBidStatus",
    SaveUnauthorziedBookIntake:
      configJson.baseUrl + "/api/Intake/SaveUnauthorziedBookIntakeDetails",
    GetActiveQueueReport:
      configJson.baseUrl + "/api/Intake/GetActiveQueueReport",
    ValidateBulkRack:
      configJson.baseUrl + "/api/BulkRackUpdate/CheckRackUpdateValidation",
    SubmitBulkRack:
      configJson.baseUrl + "/api/BulkRackUpdate/BulkRackUpdateAsync",
    SignOut: configJson.baseUrl + "/api/Logout/Revoketoken",
    GetFileFromS3: configJson.baseUrl + "/api/S3Download/GetFileFromS3",
    GetBIDsWithStatusTimeElapsed:
      configJson.baseUrl + "/api/Report/GetBIDsWithStatusTimeElapsed",
    GetBIDsWithStatusFilter:
      configJson.baseUrl + "/api/Report/GetBIDsWithStatusFilter",
    GetRoleBasedPages: configJson.baseUrl + "/api/Role/GetRoleBasedPages",
    QCPassedButNotDeliveredtoS3:
      configJson.baseUrl + "/api/QC/GetQCPassedNotDS3Queue",
    GetExceptionActionByBID:
      configJson.baseUrl + "/api/Intake/GetExceptionActionByBID",
    GetExceptionActionStatus:
      configJson.baseUrl + "/api/Intake/GetExceptionActionStatus",
    ExceptionActionSubmit:
      configJson.baseUrl + "/api/Intake/ExceptionActionSubmit",
    GetRegexValidation: configJson.baseUrl + "/api/RackShelfRegex/GetRegexData",
    GetClientBIDDetails: configJson.baseUrl + "/api/Recycle/GetBookByBID",
    SubmitSelfFixed: configJson.baseUrl + "/api/Client/ClientSelffix",
    GetBIDConfirmationByRack:
      configJson.baseUrl + "/api/Recycle/GetBIDConfirmationByRack",
    GetRackBids: configJson.baseUrl + "/api/Recycle/GetBIDConfirmationQueue",
    SubmitRecycleId: configJson.baseUrl + "/api/Recycle/BIDConfirmationSubmit",
    BookRackUpdateAsync:
      configJson.baseUrl + "/api/Recycle/BookRackUpdateAsync",
    GetBinDetails: configJson.baseUrl + "/api/RecycleManifest/GetBinDetails",
    DownloadBinManifest:
      configJson.baseUrl + "/api/RecycleManifest/DownloadBinManifest",
    GetBinDetailsForShipment:
      configJson.baseUrl + "/api/Shipment/GetRecycleShipmentQueue",
    RecycleShipmentSubmit:
      configJson.baseUrl + "/api/Shipment/RecycleShipmentSubmit",
    GetRecycleShipmentArchive:
      configJson.baseUrl + "/api/Shipment/GetRecycleShipmentArchive",
    GetLoadTrackingQueueByLoadId:
              configJson.baseUrl + "/api/Recycle/GetLoadTrackingQueueByLoadId",
    GetRecycleCODHistory: configJson.baseUrl + "/api/RecycleCOD/GetRecycleCODHistory",
          GetRecycleCODQueue:
      configJson.baseUrl + "/api/RecycleCOD/GetRecycleCODQueue",
                RecycleCODSubmit:
      configJson.baseUrl + "/api/RecycleCOD/RecycleCODSubmit",
      GetQCErrorCategoryList:
      configJson.baseUrl + "/api/QC/GetQCErrorCategoryList",
            CreateQCErrorCategory:
      configJson.baseUrl + "/api/QC/CreateQCErrorCategory",
            UpdateQCErrorCategory:
      configJson.baseUrl + "/api/QC/UpdateQCErrorCategory",
            GetQCErrorCategoryById:
            configJson.baseUrl + "/api/QC/GetQCErrorCategoryById",
        GetLanguageList:
            configJson.baseUrl + "/api/Language/GetLanguageList",
        CreateLanguage:
            configJson.baseUrl + "/api/Language/CreateLanguage",
        UpdateLanguage:
            configJson.baseUrl + "/api/Language/UpdateLanguage",
        GetLanguageById:
            configJson.baseUrl + "/api/Language/GetLanguageById",
        GetLanguageListwithCode:
            configJson.baseUrl + "/api/Language/GetLanguageListwithCode",
                             SaveIntakeRejectBookDetails:
            configJson.baseUrl + "/api/Intake/SaveIntakeRejectBookDetails",
                             GetRejectReasonsMaster:
            configJson.baseUrl + "/api/Masters/GetRejectReasons",  
        SaveCuttingRejectBookDetails: configJson.baseUrl + "/api/Cutting/RejectCuttingProcess",
                GetRejectReasonList:
            configJson.baseUrl + "/api/RejectReason/GetRejectReasonList",
        CreateRejectReason:
            configJson.baseUrl + "/api/RejectReason/CreateRejectReason",
        UpdateRejectReason:
            configJson.baseUrl + "/api/RejectReason/UpdateRejectReason",
        GetRejectReasonById:
            configJson.baseUrl + "/api/RejectReason/GetRejectReasonById",
        GetRejectReasons:
            configJson.baseUrl + "/api/RejectReason/GetRejectReasons",
                   SaveQcRejectBookDetails:
            configJson.baseUrl + "/api/QC/RejectQCProcess", 
        RecoveryActionSubmit:
            configJson.baseUrl + "/api/ExceptionAction/RecoveryActionSubmit",
        GetExceptionLogList:
            configJson.baseUrl + "/api/ExceptionAction/GetExceptionLogList",
                            GetMainFieldRegexData: configJson.baseUrl + "/api/RackShelfRegex/GetMainFieldRegexData",

        GetBookChangeByBIDandStatus: configJson.baseUrl + "/api/ManualDateProcess/ManualTimeGetBookStatus",
        GetManualTimeStationHistory: configJson.baseUrl + "/api/ManualDateProcess/ManualTimeGetStationHistory",
        SubmitUpsertStationTimes: configJson.baseUrl + "/api/ManualDateProcess/UpsertStationTimes",
        GetLegalBatchList: configJson.baseUrl + "/api/LegalBatch/GetLegalBatchList",
        GetProcessedISBNList: configJson.baseUrl + "/api/LegalBatch/GetProcessedISBNList",
        GetBillingReport: configJson.baseUrl + "/api/Report/GetBillingReport",
        GetRejectionReport: configJson.baseUrl + "/api/Report/GetRejectionReport",
        GetExternalAPIList: configJson.baseUrl + "/api/ExternalAPI/GetExternalAPIList",
        CreateExternalAPI: configJson.baseUrl + "/api/ExternalAPI/CreateExternalAPI",
        UpdateExternalAPI: configJson.baseUrl + "/api/ExternalAPI/UpdateExternalAPI",
        GetExternalAPIById: configJson.baseUrl + "/api/ExternalAPI/GetExternalAPIById",
        GetClientFeedbackLog: configJson.baseUrl + "/api/VendorFeedback/GetClientFeedbackLog",
        GetProcessedFeedbackList: configJson.baseUrl + "/api/VendorFeedback/GetProcessedFeedbackList",
        GetDeliveryToS3AutomationLog: configJson.baseUrl + "/api/VendorFeedback/GetDeliveryToS3AutomationLog",
        GetProcessedDeliveryToS3List: configJson.baseUrl + "/api/VendorFeedback/GetProcessedDeliveryToS3List",
        GetQueueColumnMaster: configJson.baseUrl + "/api/Report/GetQueueColumnMaster",
        GetLegalDataVerifierReport: configJson.baseUrl + "/api/Report/GetLegalDataVerifierReport",
        GetVendorNames: configJson.baseUrl + "/api/Masters/GetVendors",
        GetISBNVendorMaster: configJson.baseUrl + "/api/ISBNVendorMaster/GetISBNVendorMaster",
        GetISBNVendorMasterList: configJson.baseUrl + "/api/ISBNVendorMaster/GetISBNVendorMasterList",
        CreateISBNVendorMaster: configJson.baseUrl + "/api/ISBNVendorMaster/CreateISBNVendorMaster",
        UpdateISBNVendorMaster: configJson.baseUrl + "/api/ISBNVendorMaster/UpdateISBNVendorMaster",
        GetISBNVendorMasterById: configJson.baseUrl + "/api/ISBNVendorMaster/GetISBNVendorMasterById",
        InsertDeliveryS3Failure: configJson.baseUrl + "/api/VendorFeedback/InsertDeliveryS3Failure",
        UpdateVendorFeedbackRetry: configJson.baseUrl + "/api/VendorFeedback/UpdateVendorFeedbackRetry",
        GetBookByBIDBatch: configJson.baseUrl + "/api/Cutting/GetBooksByBatch",
        GetRoleBasedFieldAccess: configJson.baseUrl + "/api/Role/GetRoleBasedFieldAccess",
        GetRoleManagementList: configJson.baseUrl + "/api/Role/GetRoleManagementList",
        UpdateRestriction: configJson.baseUrl + "/api/Role/UpdateRestriction",
        GetMRBQueueDetails: configJson.baseUrl + "/api/Intake/GetMRBQueueDetails",
        SubmitMRBQueue: configJson.baseUrl + "/api/Intake/SubmitMRBQueue",
        GetVendorDetailsByISBN: configJson.baseUrl + "/api/Intake/GetVendorDetailsByISBN"
  },
};

export default CommonObj;
